export const TYPES_ACTIVITE = [
{id: "A", description: "Autre"}, 
{id: "AN", description: "Activite Nautique"}, 
{id: "BS", description: "Baignade Avec Surveillance"}, 
{id: "CS", description: "Camping Avec Ou Sans Service"}, 
{id: "C", description: "Canot"}, 
{id: "CG", description: "Canot Guide"}, 
{id: "EA", description: "Excursion Autoneige"}, 
{id: "EAH", description: "Excursion Avion Ou Hydravion"}, 
{id: "EM", description: "Excursion Mer"}, 
{id: "G", description: "Glissade"}, 
{id: "ISF", description: "Initiation Survie Foret"}, 
{id: "ICA", description: "Interpretation Culture Autochtone"}, 
{id: "IN", description: "Interpretation Nature"}, 
{id: "K", description: "Kayak"}, 
{id: "KM", description: "Kayak Mer"}, 
{id: "KMG", description: "Kayak Mer Guide"}, 
{id: "M", description: "Motoneige"}, 
{id: "MG", description: "Motoneige Guidee"}, 
{id: "OO", description: "Observation Ours"}, 
{id: "OF", description: "Observation Faune"}, 
{id: "OFG", description: "Observation Faune Guide"}, 
{id: "P", description: "Patinage"}, 
{id: "Q", description: "Quad"}, 
{id: "QG", description: "Quad Guide"}, 
{id: "REG", description: "Randonnee Equestre Guidee"}, 
{id: "RP", description: "Randonnee Pedestre"}, 
{id: "R", description: "Raquette"}, 
{id: "SR", description: "Ski Randonnee"}, 
{id: "TC", description: "Traineaux Chiens"}, 
{id: "VM", description: "Velo Montagne"}, 
];